<template>
    <div class="loading-arrow-overlay" v-if="visible">
        <div class="loading-arrow-center">
            <img class="loading-arrow-img" src="./arror.png" alt="loading-arrow" width="48" height="48" />
            <div class="loading-arrow-text" v-if="text">{{ loadingText }}</div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'LoadingArrow',
  props: {
    visible: {
      type: Boolean,
      default: true,
    },
    text: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters(['app']),
    // 检测传入的文本是否有 「...」，如果没有就加上
    // 原因是多语言文案不一致，为保证别处不改动，故在组件内部处理
    loadingText() {
      if (this.text.includes('...')) {
        return this.text;
      }
      return `${this.text}...`;
    },
  },
};
</script>

<style scoped>
.loading-arrow-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: #fff;
    z-index: 99999;
    display: flex;
    align-items: center;
    justify-content: center;
}

.loading-arrow-center {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.loading-arrow-img {
    animation: loading-arrow-spin 1s linear infinite;
    display: block;
    width: 16px;
    height: 16px;
    margin-bottom: 6px;
    padding: 2px;
}

@keyframes loading-arrow-spin {
    100% {
        transform: rotate(360deg);
    }
}

.loading-arrow-text {
    /* color: rgba(33, 43, 54, 1); */
    font-family: Open Sans regular;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 0px;
    text-align: center;
}
</style>
